module.exports = __webpack_public_path__ + "img/pluto87.a34ff159.jpg";